import styles from './style.module.css';
import Modal from 'react-responsive-modal';
import alert from '../../../../assets/images/alert.png';
import { Button } from '../../../../components/Button';

interface IModalCheckoutEMR {
  modalIsOpen: boolean;
  urlCheckout: string;
  toggleModal: () => void;
}

export function ModalCheckoutEMR({
  modalIsOpen,
  toggleModal,
  urlCheckout,
}: IModalCheckoutEMR) {
  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <div className="contents-modal">
        <div className="d-flex justify-content-center">
          <img className={styles.alert} src={alert} alt="Cadastro confirmado" />
        </div>
        <h1 className="title-modal">Cadastro já realizado!</h1>
        <p className="subtitle-modal">
          Olá, identificamos que já fez o seu cadastro. Que Legal! Vamos te
          direcionar para o seu checkout.
        </p>
      </div>
      <div className={styles.contentBtn}>
        <Button
          isModal
          text="Comprar agora"
          type="button"
          color="primary"
          onClick={() => {
            location.href = urlCheckout ? urlCheckout : '';
            toggleModal();
          }}
        />
      </div>
    </Modal>
  );
}
